import React from 'react'

const ArrowDownSvg = ({ width, height, stroke = '#b5ccc2' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 17.284 9.642'
    >
      <path
        id='Path_3128'
        data-name='Path 3128'
        d='M347.545,507.2l7.228,7.228L362,507.2'
        transform='translate(-346.131 -505.782)'
        fill='none'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  )
}

export default ArrowDownSvg
